/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_LogoInputs */

const cs_templates_branding_logo = /** @type {(inputs: Templates_Branding_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo kanceláře`)
};

const en_templates_branding_logo = /** @type {(inputs: Templates_Branding_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office logo`)
};

/**
* | output |
* | --- |
* | "Office logo" |
*
* @param {Templates_Branding_LogoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_logo = /** @type {((inputs?: Templates_Branding_LogoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_LogoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_logo(inputs)
	return cs_templates_branding_logo(inputs)
});